import { MessageCircleMore, X } from 'lucide-react';
import { useShallow } from 'zustand/react/shallow';
import appStore from '@/stores/app.store.ts';

export default function Messengers() {
	const { visible, toggle } = appStore(
		useShallow((state) => ({ toggle: state.toggleMessenger, visible: state.isMessengerOpen })),
	);

	return (
		<div className="flex flex-col justify-center items-center gap-3 fixed bottom-2 right-2 z-100">
			<a
				href="https://t.me/jervicepl"
				className="w-12 h-12 flex items-center justify-center translate-y-10 opacity-0 invisible transition-all data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0 data-[visible=true]:visible min-lg:data-[visible=true]:opacity-0 min-lg:data-[visible=true]:translate-y-10 min-lg:data-[visible=true]:invisible min-lg:data-[visible=false]:opacity-100 min-lg:data-[visible=false]:translate-y-0 min-lg:data-[visible=false]:visible"
				data-visible={visible}
				title="Telegram"
				target="_blank"
			>
				<img src="/icons/telegram.svg" alt="telegram" className="w-full h-full object-contain" />
			</a>

			<a
				href="https://wa.me/message/CFQEM4QMLR3CA1"
				className="w-12 h-12 flex items-center justify-center translate-y-10 opacity-0 invisible transition-all data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0 data-[visible=true]:visible min-lg:data-[visible=true]:opacity-0 min-lg:data-[visible=true]:translate-y-10 min-lg:data-[visible=true]:invisible min-lg:data-[visible=false]:opacity-100 min-lg:data-[visible=false]:translate-y-0 min-lg:data-[visible=false]:visible"
				data-visible={visible}
				title="Whatsapp"
				target="_blank"
			>
				<img src="/icons/whatsapp.svg" alt="whatsapp" className="w-full h-full object-contain" />
			</a>

			<button
				className="w-14 h-14 flex cursor-pointer hover:brightness-95 border-2 border-white active:scale-97 items-center justify-center bg-[var(--primary)] text-white rounded-full"
				onClick={toggle}
			>
				<X
					size="1.75rem"
					data-visible={visible}
					className="absolute opacity-0 invisible transition-all data-[visible=true]:opacity-100 data-[visible=true]:visible min-lg:opacity-100 min-lg:visible min-lg:data-[visible=true]:opacity-0 min-lg:data-[visible=true]:invisible"
				/>
				<MessageCircleMore
					size="1.75rem"
					data-visible={visible}
					className="absolute transition-all opacity-0 invisible min-lg:opacity-100 min-lg:visible data-[visible=false]:opacity-100 data-[visible=false]:visible min-lg:data-[visible=false]:opacity-0 min-lg:data-[visible=false]:invisible"
				/>
			</button>
		</div>
	);
}
